import { LitElement, TemplateResult, html } from "lit";
import { customElement } from "lit/decorators.js";
import { SlhCoreBreadcrumbs } from "@slhuicore/breadcrumbs";
import { IconDefaultType as IconType } from "@slhuiicon/icon";

import { style } from "./assets/breadcrumbs.generated-style";

/**
 * A breadcrumbs component shows where in the site hierarchy the user is. It allows users to choose from a range of values.
 *
 * @CustomElement slh-breadcrumbs
 *
 * @cssprop --slh-color-neutral-shade-60 - Mobile link and icon fill color.
 * @cssprop --slh-color-primary - Last element and dots color. Mobile link and icon fill color.
 * @cssprop --slh-base-semi-bold-font-weight - Mobile link font weight.
 * @cssprop --slh-base-xs-font-size - Mobile link font size.
 *
 * @slot default - Breadcrumb items.
 */
@customElement("slh-breadcrumbs")
export default class SlhBreadcrumbs extends SlhCoreBreadcrumbs(LitElement) {
  static styles = style;

  // eslint-disable-next-line class-methods-use-this
  protected renderIconTemplate(): TemplateResult {
    return html`<slh-icon type="${IconType.ICO_ARROW_OPEN_LEFT}"></slh-icon>`;
  }

  // eslint-disable-next-line class-methods-use-this
  protected createItemElement(): HTMLElement {
    return document.createElement("slh-breadcrumb-item");
  }
}
